import { NavLink } from "react-router-dom";
import {
  Gauge,
  Lightning,
  XCircle,
  Terminal,
  ChartLineUp,
  Gear,
  Pulse,
  Wallet,
} from "@phosphor-icons/react";
import { cn } from "@/lib/utils";
import { NAV } from "@/constants/testIds";

const items = [
  { to: "/", label: "Dashboard", icon: Gauge, testid: NAV.dashboard, end: true },
  { to: "/signals", label: "Signals", icon: Lightning, testid: NAV.signals },
  { to: "/rejected", label: "Rejected", icon: XCircle, testid: NAV.rejected },
  { to: "/paper", label: "Paper Trading", icon: Wallet, testid: NAV.paper },
  { to: "/logs", label: "Logs", icon: Terminal, testid: NAV.logs },
  { to: "/backtest", label: "Backtest", icon: ChartLineUp, testid: NAV.backtest },
  { to: "/settings", label: "Settings", icon: Gear, testid: NAV.settings },
];

export const Sidebar = () => {
  return (
    <aside className="hidden md:flex md:w-[240px] lg:w-[260px] shrink-0 flex-col border-r border-slate-200/70 bg-[#f8fafc] min-h-screen">
      <div
        data-testid={NAV.sidebarBrand}
        className="px-5 py-5 border-b border-slate-200/70 flex items-center gap-2"
      >
        <Pulse size={20} weight="bold" className="text-[#2563eb] pulse-dot" />
        <div className="font-heading font-black tracking-tight text-slate-900 text-lg leading-none">
          WEEX<span className="text-[#2563eb]">·</span>SIGNALS
        </div>
      </div>
      <nav className="flex-1 p-3 flex flex-col gap-1">
        {items.map((it) => (
          <NavLink
            key={it.to}
            to={it.to}
            end={it.end}
            data-testid={it.testid}
            className={({ isActive }) =>
              cn(
                "flex items-center gap-3 px-3 py-2 rounded-sm text-sm transition-all font-data",
                isActive
                  ? "bg-[#e2e8f0] text-slate-900 border-l-2 border-[#2563eb]"
                  : "text-slate-600 hover:text-slate-900 hover:bg-[#f1f5f9] border-l-2 border-transparent",
              )
            }
          >
            <it.icon size={16} weight="bold" />
            <span className="tracking-wide">{it.label}</span>
          </NavLink>
        ))}
      </nav>
      <div className="p-3 border-t border-slate-200/70 text-[10px] tracking-[0.2em] uppercase text-slate-400">
        Phase 1 · Public Mode
      </div>
    </aside>
  );
};
